export default __webpack_public_path__ + "static/media/custom-ipad3.f5d95299.png";